// src/services/sse/utils/auth.ts
/**
 * Authentication utilities for SSE connections.
 * 
 * EventSource doesn't support custom headers, so we pass token as query param.
 */
import { supabase } from '../../../lib/supabaseClient.ts';
import { API_URL } from '../../api.ts';

/**
 * Get auth token for SSE connections.
 * Tries Supabase token first, falls back to backend token.
 */
export const getAuthToken = async (): Promise<string | null> => {
  try {
    // Try Supabase token first
    const { data } = await supabase.auth.getSession();
    if (data.session?.access_token) {
      return data.session.access_token;
    }
    // Fallback to backend token
    const backendToken = localStorage.getItem('authToken');
    return backendToken;
  } catch (e) {
    return null;
  }
};

/**
 * Create SSE connection URL with auth token.
 */
export const createStreamURL = (endpoint: string, token: string | null): string => {
  if (!token) {
    throw new Error('Authentication required');
  }
  return `${API_URL}/stream/${endpoint}?token=${encodeURIComponent(token)}`;
};

